<template>
    <div class="card">
        <div class="card-body">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th v-sort:name>Название</th>
                        <th v-if="hasCrt" v-sort:vat>НДС</th>
                        <th v-if="hasGtin && gtinIsVisible" v-sort:gtin>GTIN</th>
                        <th>Себестоимость</th>
                        <th class="action-buttons" />
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="product in products" :key="product.id">
                        <td class="truncate">{{ product.name }}</td>
                        <td v-if="hasCrt" class="text-nowrap">{{ product.vat | vat }}</td>
                        <td v-if="hasGtin && gtinIsVisible" class="text-nowrap">{{ product.gtin }}</td>
                        <td>
                            <template v-if="product.components[0].net_price">
                                <div>
                                    {{ product.components[0].net_price }} {{ currency | currencySymbol }}
                                </div>
                            </template>

                            <template v-else>
                                <span class="text-muted">Не задана</span>
                            </template>
                        </td>

                        <td class="action-buttons">
                            <router-link :to="{ name: 'stocks.products.show', params: { id: product.id }}" class="btn btn-icon btn-edit" />
                            <button type="button" class="btn btn-icon btn-remove" @click.prevent="remove(product.id)" />
                        </td>
                    </tr>
                </tbody>

                <tfoot v-if="noOne" class="no-one">
                    <tr>
                        <td colspan="42">Вы пока не добавили ни одного продукта.</td>
                    </tr>
                </tfoot>

                <tfoot v-if="noFound" class="no-one">
                    <tr>
                        <td colspan="42">По вашему запросу не найдено ни одного продукта.</td>
                    </tr>
                </tfoot>

                <tfoot v-if="meta.last_page > 1">
                    <tr>
                        <td colspan="42">
                            <pagination :meta="meta" @input="applyFilter({ page: $event })" />
                        </td>
                    </tr>
                </tfoot>
            </table>

            <router-view />
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'

import store from '@/store'
import { toastSuccess, toastError, confirm, getUsageMessage } from '@/dialogs'

export default {
    components: {
        Pagination
    },

    props: {
        filter: {
            type: Object,
            default: _ => ({})
        }
    },

    computed: {
        gtinIsVisible() {
            return this.$store.getters['stocks/gtinIsVisible']
        },

        products() {
            return this.$store.getters['stocks/data'] || []
        },

        meta() {
            return this.$store.getters['stocks/meta'] || {}
        },

        isMobile() {
            return this.$store.state.isMobile
        },

        noOne() {
            return this.products.length === 0 && !this.filter.search
        },

        noFound() {
            return this.products.length === 0 && this.filter.search
        },

        hasCrt() {
            return this.$store.getters['company/hasCrt']
        },

        hasGtin() {
            return this.$store.getters['company/hasGtin']
        },

        currency() {
            return this.$store.state.company.profile.data.currency || null
        }
    },

    methods: {
        async remove(id) {
            if (!await this.$store.dispatch('stocks/getUsage', id)) {
                return toastError('Ошибка')
            }

            if (!await confirm('Удалить?', getUsageMessage(this.$store.state.stocks.usage))) {
                return
            }

            const done = await this.$store.dispatch('stocks/remove', id)

            if (done) {
                toastSuccess('Удалено')
            } else {
                return toastError('Ошибка')
            }
        }
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch('stocks/fetchAll', { ...to.query, recipe: 0 })
        next()
    },

    async beforeRouteUpdate(to, from, next) {
        await store.dispatch('stocks/fetchAll', { ...to.query, recipe: 0 })
        next()
    }
}
</script>
